import React from 'react';

type TitleProps = {
  icon: string;
  alt?: string;
};

/**
 * @description Header에 들어가는 Application Title 컴포넌트
 * @property {string} icon Title Logo 경로
 * @property {string | undefined} alt Title Icon 이미지 alt 값
 * @property {string} link 로고 클릭시 이동할 경로
 */
function Title({ icon, alt }: TitleProps) {
  return (
    <div className="title-wrapper wrapper">
      <img src={icon} alt={alt} />
    </div>
  );
}

export default Title;
